// extracted by mini-css-extract-plugin
export default {"languageSelectContainer":"GeneralSection_languageSelectContainer__T8i2f","languageSelect":"GeneralSection_languageSelect__Wc5Kr"};